import React from 'react'
import SvgLogoGrafenoCompact from '../../assets/svg-logo-grafeno-compact'
import SvgLogoGrafeno from '../../assets/svg-logo-grafeno'
import * as Styles from './styles'

type Props = {
  compact: boolean
  alt?: boolean
}

const LogoGrafeno: React.FC<any> = (props: Props) => {
  const altTheme = `${props.alt ? 'is-alt' : ''}`

  return (
    <Styles.Logo className={altTheme}>
      {props.compact ? <SvgLogoGrafenoCompact /> : <SvgLogoGrafeno />}
    </Styles.Logo>
  )
}

export default LogoGrafeno

LogoGrafeno.defaultProps = {
  alt: false,
}
